<template>
    <button class="calendar-list-event" type="button" @click="openDialog">
        <div class="calendar-list-event__header">
            <span class="calendar-list-event__time" v-if="!event.hideStartTime">{{ event.formattedTime }}</span>
            <h4 class="calendar-list-event__title" v-html="event.title" />

            <p
                class="calendar-list-event__venue"
                v-if="event.event.venue"
            >{{ event.event.venue.title }}</p>

            <ul class="calendar-popup-item__tags" v-if="event.attributes?.custom?.tags?.length">
                <li class="calendar-popup-item__tag" v-for="(keyword, index) in event.attributes.custom.tags" :key="index">
                    {{keyword}}
                </li>
            </ul>

            <div v-if="event.filters?.categories" class="calendar-list-event__footer">
                <calendar-info :event="event"/>
            </div>
        </div>

        <figure
            v-if="event.image"
            class="calendar-list-event__media o-figure"
            itemscope
            itemtype="http://schema.org/ImageObject"
        >
            <picture class="calendar-list-event__intrinsic-ratio">
                <source
                    :srcset="`
                        ${getImageURL(event.image.src, 180, 150)},
                        ${getImageURL(event.image.src, 360, 300)} 2x`"
                    media="(min-width: 800px)"
                >
                <img
                    class="calendar-list-event__image"
                    :src="getImageURL(event.image.src, 180, 150)"
                    width="500"
                    height="250"
                    :alt="event.image.alt || ''"
                >
            </picture>
        </figure>
    </button>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue';
import CalendarInfo from './calendar-info.vue';
import { setState } from '../services/stateful';

export default defineComponent({
    name: 'CalendarListEvent',
    components: { CalendarInfo },
    props: {
        event: {
            type: Object,
            required: true,
        },
        opendialog: {
            type: Function,
            required: true,
        }
    },
    setup(props) {
        const getImageURL = (url, width, height) => {
            return url + '?w=' + width + '&h=' + height;
        }

        const openDialog = (() => {
            setState('calendar-popup.open-event', props.event);
        });

        return {
            openDialog,
            getImageURL
        };
    },
});
</script>
